import { render, staticRenderFns } from "./countCard.vue?vue&type=template&id=06c4a33f&scoped=true&"
import script from "./countCard.vue?vue&type=script&lang=js&"
export * from "./countCard.vue?vue&type=script&lang=js&"
import style0 from "./countCard.vue?vue&type=style&index=0&id=06c4a33f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06c4a33f",
  null
  
)

export default component.exports